import { useQuery } from "@tanstack/react-query";
import { appointmentService } from "..";

type Props = {
  fromDate: string;
  toDate: string;
  // Calendar: keep showing the previous range while the next one loads and keep visited ranges cached.
  // Data is still refetched on every range change (staleTime unchanged).
  keepPrevious?: boolean;
};

const useGetDailyAppointment = ({ fromDate, toDate, keepPrevious }: Props) =>
  useQuery({
    queryKey: ["getDailyAppointment", fromDate, toDate],
    queryFn: () => appointmentService.getDailyAppointment(fromDate, toDate),
    select: (res) => res,
    staleTime: 30,
    cacheTime: keepPrevious ? 5 * 60 * 1000 : 30,
    keepPreviousData: keepPrevious,
  });

export { useGetDailyAppointment };
